function getAjaxUrl() {
  let baseUrl,
    host = window.location.host,
    subDomain = host.split('.')[0];
  if (subDomain === 'www-sim') {
    baseUrl = 'https://sim.rocketbird.cn';
  } else if (subDomain === 'www') {
    baseUrl = 'https://wx.rocketbird.cn';
  } else {
    baseUrl = 'https://beta.rocketbird.cn';
  }
  return baseUrl;
}

function getPcRegisterUrl() {
  let baseUrl,
    host = window.location.host,
    subDomain = host.split('.')[0];
  if (subDomain === 'www-sim') {
    baseUrl = 'https://sim.rocketbird.cn/Admin/MerchantsRegister/index';
  } else if (subDomain === 'www') {
    baseUrl = 'https://wx.rocketbird.cn/Admin/MerchantsRegister/index';
  } else {
    baseUrl = 'https://beta.rocketbird.cn/Admin/MerchantsRegister/index';
  }
  return baseUrl;
}

function getPhoneRegisterUrl() {
  let baseUrl,
    host = window.location.host,
    subDomain = host.split('.')[0];
  if (subDomain === 'www-sim') {
    baseUrl = 'https://vip-sim.rocketbird.cn/register.html';
  } else if (subDomain === 'www') {
    baseUrl = 'https://vip.rocketbird.cn/register.html';
  } else {
    baseUrl = 'https://vip-test.rocketbird.cn/register.html';
  }
  return baseUrl;
}

function goRegisterUrl(val) {
  const search = window.location.search;
  let phone = val ? 'phone=' + val : '';
  let phoneStr = phone ? '&' + phone : ''
  const newSearch = search ? search + phoneStr : phone ? '?' + phone : ''
  if (document.body && document.body.clientWidth >= 480) {
    window.open(getPcRegisterUrl() + newSearch);
  } else {
    window.open(getPhoneRegisterUrl() + newSearch);
  }
}

function setHTMLFontSize() {
  const windowWidth = $(window).width();
  let fontSize = 100; // windowWidth / 19.20

  if (windowWidth <= 479) {
    fontSize = windowWidth / 7.50;
    // console.log(windowWidth, fontSize);
    $('html').css('fontSize', fontSize + 'px');
  }
}

!(function() {
  setHTMLFontSize();
  // $(window).on('resize', setHTMLFontSize);

  const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

  function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) e.preventDefault();
    e.returnValue = false;
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  let oldonwheel, oldonmousewheel1, oldonmousewheel2, oldontouchmove, oldonkeydown, isDisabled;

  function disableScroll() {
    if (window.addEventListener)
      // older FF
      window.addEventListener('DOMMouseScroll', preventDefault, false);
    oldonwheel = window.onwheel;
    window.onwheel = preventDefault; // modern standard

    oldonmousewheel1 = window.onmousewheel;
    window.onmousewheel = preventDefault; // older browsers, IE
    oldonmousewheel2 = document.onmousewheel;
    document.onmousewheel = preventDefault; // older browsers, IE

    oldontouchmove = window.ontouchmove;
    window.ontouchmove = preventDefault; // mobile

    oldonkeydown = document.onkeydown;
    document.onkeydown = preventDefaultForScrollKeys;
    isDisabled = true;
  }

  function enableScroll() {
    if (!isDisabled) return;
    if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false);

    window.onwheel = oldonwheel; // modern standard

    window.onmousewheel = oldonmousewheel1; // older browsers, IE
    document.onmousewheel = oldonmousewheel2; // older browsers, IE

    window.ontouchmove = oldontouchmove; // mobile

    document.onkeydown = oldonkeydown;
    isDisabled = false;
  }

  window.scrollHanlder = {
    disableScroll: disableScroll,
    enableScroll: enableScroll
  };

  $(function() {
    const html = $('html,body');
    const windowWidth = html.width();
    const phoneNav = $('#phoneNav'); // 移动端 侧边nav
    const phoneNavModal = $('#phone-nav-modal'); // 移动端 侧边nav遮罩层
    const initialNavRight = parseInt(phoneNav.css('right'));
    const toTop = $('#toTop');
    const fixedNavMenu = $('#fixedNav');
    let changedNavRight = 0;
    let touchStart = 0;

    toTop.on('click', function() {
      html.animate({ scrollTop: 0 }, 600, 'swing', function() {
        html.stop(true);
      });
    });

    $(document).on('scroll', function() {
      var scrollTop = $(document).scrollTop();
      if (scrollTop >= 600 && windowWidth >= 480) {
        fixedNavMenu.fadeIn(600);
      } else {
        fixedNavMenu.fadeOut(600);
      }
      if (scrollTop >= 300 && windowWidth >= 480) {
        toTop.fadeIn(600);
      } else {
        toTop.fadeOut(600);
      }

      /* if (windowWidth <= 480 && scrollTop >= 45) {
        $('#navIcon').addClass('nav-icon-bg');
      }else {
        $('#navIcon').removeClass('nav-icon-bg');
      } */
    });

    html.on('touchstart', function(e) {
      touchStart = e.touches[0].clientX;
      changedNavRight = parseInt(phoneNav.css('right'));
    });

    html.on('touchmove', function(e) {
      if (touchStart < windowWidth * 0.9) {
        return;
      }
      var touchEnd = e.touches[0].clientX;
      var changesTouches = touchStart - touchEnd;
      var setPhoneNavRight = changedNavRight + changesTouches;
      setPhoneNavRight = setPhoneNavRight >= 0 ? 0 : setPhoneNavRight;
      phoneNav.css('right', setPhoneNavRight);
    });

    html.on('touchend', function(e) {
      if (touchStart < windowWidth * 0.9) {
        return;
      }
      var touchEnd = e.originalEvent.changedTouches[0].clientX;
      var changesTouches = touchStart - touchEnd;
      var setPhoneNavRight = changedNavRight + changesTouches;
      setPhoneNavRight = setPhoneNavRight >= initialNavRight / 2 ? 0 : initialNavRight;
      setPhoneNavRight === 0 ? phoneNavModal.addClass('show') : phoneNavModal.removeClass('show');
      phoneNav.css('right', setPhoneNavRight);
    });

    $('#navIcon').on('click', function() {
      $('#navBar').addClass('nav-bar-ac');
      phoneNav.css('right', 0);
      phoneNavModal.addClass('show');
    });

    $('#closeNav').on('click', function() {
      $('#navBar').removeClass('nav-bar-ac');
      phoneNav.css('right', initialNavRight);
      phoneNavModal.removeClass('show');
    });

    phoneNavModal.on('click', function() {
      $('#closeNav').trigger('click');
    });

    const tryButton = $('#tryWithPhone');
    const phone = $('#phone');
    tryButton.on('click', function() {
      const val = phone.val();
      goRegisterUrl(val)
    });

    const phoneScroll = $('#phoneScroll');
    const phoneArrow = $('#phoneArrow');
    phoneScroll.on('scroll', function() {
      phoneArrow.hide(100);
    });

    const getSale = $('#getSale');
    const saleModal = $('#saleModal');
    const close = saleModal.find('.close');
    const salePhone = $('#salePhone');
    const saleSubmit = $('#saleSubmit');
    getSale.on('click', function() {
      saleModal.css({ display: 'flex' });
    });
    close.on('click', function() {
      saleModal.css({ display: 'none' });
    });
    saleSubmit.on('click', function() {
      const phone = salePhone.val();
      if (!phone) {
        saleModal.css({ display: 'none' });
      } else {
        const valid = /^1\d{10}$/.test(phone);
        if (!valid) {
          return alert('手机号错误');
        }
        $.post(`${getAjaxUrl()}/Web/News/addPhone`, { phone }, res => {
          if (res.errorcode === 0) {
            saleModal.css({ display: 'none' });
            alert('提交成功！我们将第一时间与您取得联系')
          } else {
            alert(res.errormsg)
          }
        });
      }
    });
  });

  // 设置备案时间
  const year = new Date().getFullYear();
  $('#recordTime').html(`Copyright © 2016-${year} 重庆勤鸟圈科技有限公司 All Rights Reserved. <a class="beian-link" href="https://beian.miit.gov.cn">渝ICP备16001255号-1</a>`);
})();
